import { ThomasCampaign } from 'models/interfaces';
import { v4 as uuid } from 'uuid';

function buildThomasCampaign() {
  const thomasCampaign = <ThomasCampaign>{};
  thomasCampaign.campaign_id = uuid();

  return thomasCampaign;
}

export { buildThomasCampaign };
